import type { DrawerItem } from '@/components/subject/configs.ts';

const experiments: DrawerItem[] = [
  // {
  //   title: '5.圆锥曲线中的定值、定点问题',
  //   icon: 'lucide:folder',
  //   children: [
  //     { title: '圆锥曲线辅助画图工具', icon: 'lucide:flask-conical', route: `/experiment/conic-section` },
  //   ],
  // },
];

const experimentConfig = {
  experiments,
};

export { experimentConfig };
